import type { FaireProductEntity } from "../../entity_types/product";

export const p_v6z9pyzyjj: FaireProductEntity = {
  token: "p_v6z9pyzyjj",
  type: "product",
  name: "Multi-color Lucky Eye Ceramic Statue - 2 Pcs",
  brandToken: "b_b8csz3xa8h",
  brandName: "Gypsy Soul",
  imageUrl:
    "https://cdn.faire.com/fastly/bd3754e6d1b2bd20daa8628202e4a08a899ae6b0b5f1f08131604f3f0e99b2d2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c68944b333606fe982b4a527c552789cfe64a92d98b23af448810e22b055b4d0.jpeg",
    "https://cdn.faire.com/fastly/aa8b63483c9fe9f969253ff635511791aefcb1563ddaea871f1c08f38e14d615.jpeg",
    "https://cdn.faire.com/fastly/fc4ab309f713b1ea3e457899a24b7a30d96d3aa5a2fbe9a6affe3a81e2198a70.jpeg",
    "https://cdn.faire.com/fastly/84dcbddc1623e7e2b1f3220422398c0df61daa42238b9432fbdc1de6887f2768.jpeg",
  ],
  priceDollars: 27.7,
  description:
    'Guard your space with the timeless protection of our Evil Eye Ceramic Statue, a symbol of strength, luck, and warding off negative energy. Handcrafted with precision and care, this exquisite statue adds a touch of mystique and elegance to any environment while serving as a powerful talisman of spiritual defense.\n\nThe evil eye has been revered for centuries as a potent symbol of protection against malevolent forces and negative influences. Our ceramic statue captures the essence of this ancient symbol, infusing your space with its protective energy and shielding you from harm.\n\nPackage content:\n1 case contains 2 ceramic statue. (1 of each style)\nStand is not included\n\nWe now offer Magnetic Gift Box designed specifically for your eye statues. These boxes are shipped flat, making them easy to store and transport. \nBox Size: 8*8*8"',
  tags: [],
  msrpDollars: 55.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:26.289Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
